import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const SidebarContainer = () => {
  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const imagepath = `${process.env.REACT_APP_API_URL}/GetImage`;

  useEffect(() => {
    LoadUser();
  }, []);

  const LoadUser = () => {
    const datavalue = {
      role: "Admin",
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getProfileByRole`,
      data: JSON.stringify(datavalue),
      headers: { "Content-Type": "application/json" },
    };
    axios(authOptions)
      // axios.post(`https://localhost:7261/getIntentsByid`, datavalue, config)
      .then((res) => {
        //console.log("get value", res);
        //console.log("list", res.data.result[0].firstname)

        setfirstname(res.data.result[0].firstname);
        setlastname(res.data.result[0].lastname);
      });
  };

  return (
    <>
      {/* <!-- start sidebar menu --> */}
      <div className="sidebar-container">
        <div className="sidemenu-container navbar-collapse collapse fixed-menu">
          <div id="remove-scroll" className="left-sidemenu" style={{ backgroundColor: "#1e2e38" }}>
            <ul
              className="sidemenu  page-header-fixed slimscroll-style"
              data-keep-expanded="false"
              // data-auto-scroll="true" data-slide-speed="200" style="padding-top: 20px">
              data-auto-scroll="true"
              data-slide-speed="200"
            >
              <li className="sidebar-toggler-wrapper hide">
                <div className="sidebar-toggler">
                  <span></span>
                </div>
              </li>
              <li className="sidebar-user-panel">
                <div className="sidebar-user">
                  <div className="sidebar-user-picture">
                    {/* <img alt="image" src="img/dp.jpg" /> */}
                    <img
                      src={imagepath}
                      style={{ width: "50px" }}
                      alt="image"
                    />
                  </div>
                  <div className="sidebar-user-details">
                    {/* <div className="user-name">Dr. Kiran Patel</div> */}
                    <div className="user-role">
                      <a style={{ color: "#FFFFFF" }}>{firstname}</a> <a style={{ color: "#FFFFFF" }}>{lastname}</a>
                    </div>
                  </div>
                </div>
              </li>
              <li className="nav-item start active open">
                <a href="#" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i data-feather="airplay" style={{ color: "#FFFFFF" }}></i>

                  <Link to="/index">
                    <span className="title" style={{ color: "#FFFFFF" }}>Dashboard</span>
                  </Link>
                </a>
              </li>
              <li className="nav-item start">
                <a href="#" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i data-feather="user" style={{ color: "#FFFFFF" }}></i>
                  <span className="title" style={{ color: "#FFFFFF" }}>Cases</span>
                  <span className="selected" style={{ color: "#FFFFFF" }}></span>
                  <span className="arrow" style={{ color: "#FFFFFF" }}></span>
                </a>
                <ul className="sub-menu" style={{ backgroundColor: "#0c1317" }}>
                  <li className="nav-item">
                    <Link to="/AddCases" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>Add</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/CaseList" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>List</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/ChatGptList">
                      <span className="title" style={{ color: "#FFFFFF" }}>Logs</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/DeberiefingList">
                      <span className="title" style={{ color: "#FFFFFF" }}>Performance Logs</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/CaseManagement">
                      <span className="title" style={{ color: "#FFFFFF" }}>Case Management</span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item start">
                <a href="#" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i data-feather="slack" style={{ color: "#FFFFFF" }}></i>
                  <span className="title" style={{ color: "#FFFFFF" }}>Multi Character Cases</span>
                  <span className="selected" style={{ color: "#FFFFFF" }}></span>
                  <span className="arrow" style={{ color: "#FFFFFF" }}></span>
                </a>
                <ul className="sub-menu" style={{ backgroundColor: "#0c1317" }}>
                  <li className="nav-item">
                    <Link to="/AddScenario" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>Add</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/ScenarioList" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>List</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/ChatGptScenarioList" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>Logs</span>
                    </Link>
                  </li>
                  {/* <li className="nav-item  ">
                    <Link to="/ScenarioDeberiefingList" className="nav-link">
                      <span className="title" style={{color: "#FFFFFF"}}>Deberiefing Logs</span>
                    </Link>
                  </li> */}
                </ul>
              </li>
              <li className="nav-item start">
                <a href="#" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i data-feather="user" style={{ color: "#FFFFFF" }}></i>
                  <span className="title" style={{ color: "#FFFFFF" }}>Cases (Legacy)</span>
                  <span className="selected" style={{ color: "#FFFFFF" }}></span>
                  <span className="arrow" style={{ color: "#FFFFFF" }}></span>
                </a>
                <ul className="sub-menu" style={{ backgroundColor: "#0c1317" }}>
                  <li className="nav-item">
                    <Link to="/LAddCases" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>Add</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/LCaseList" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>List</span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item start">
                <a href="#" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i className="fa fa-user-circle-o" style={{ color: "#FFFFFF" }}></i>
                  <span className="title" style={{ color: "#FFFFFF" }}>Add Manager</span>
                  <span className="selected" style={{ color: "#FFFFFF" }}></span>
                  <span className="arrow" style={{ color: "#FFFFFF" }}></span>
                </a>
                <ul className="sub-menu" style={{ backgroundColor: "#0c1317" }}>
                  <li className="nav-item">
                    <Link to="/AddManager" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>Add</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/ManagerList" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>List</span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item start">
                <a href="#" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i className="fa fa-users" style={{ color: "#FFFFFF" }}></i>
                  <span className="title" style={{ color: "#FFFFFF" }}>User Management</span>
                  <span className="selected" style={{ color: "#FFFFFF" }}></span>
                  <span className="arrow" style={{ color: "#FFFFFF" }}></span>
                </a>
                <ul className="sub-menu" style={{ backgroundColor: "#0c1317" }}>
                  <li className="nav-item">
                    <Link to="/AddAppUser" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>Add User</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/AppUserList" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>User List</span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item start">
                <a href="#" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i className="fa fa-globe" style={{ color: "#FFFFFF" }}></i>
                  <span className="title" style={{ color: "#FFFFFF" }}>Portal</span>
                  <span className="selected" style={{ color: "#FFFFFF" }}></span>
                  <span className="arrow" style={{ color: "#FFFFFF" }}></span>
                </a>
                <ul className="sub-menu" style={{ backgroundColor: "#0c1317" }}>
                  <li className="nav-item">
                    <Link to="/AddPortal" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>Add</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/PortalList" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>List</span>
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Add Environment */}
              <li className="nav-item start">
                <a href="#" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i class="fa-solid fa-seedling" style={{ color: "#FFFFFF" }}></i>
                  <span className="title" style={{ color: "#FFFFFF" }}>Environment</span>
                  <span className="selected" style={{ color: "#FFFFFF" }}></span>
                  <span className="arrow" style={{ color: "#FFFFFF" }}></span>
                </a>
                <ul className="sub-menu" style={{ backgroundColor: "#0c1317" }}>
                  <li className="nav-item">
                    <Link to="/AddEnvironment" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>Add</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/EnvironmentList" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>List</span>
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Add Multi Character Environment */}
              <li className="nav-item start">
                <a href="#" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i class="fa-solid fa-seedling" style={{ color: "#FFFFFF" }}></i>
                  <span className="title" style={{ color: "#FFFFFF" }}>Multi-Char Env</span>
                  <span className="selected" style={{ color: "#FFFFFF" }}></span>
                  <span className="arrow" style={{ color: "#FFFFFF" }}></span>
                </a>
                <ul className="sub-menu" style={{ backgroundColor: "#0c1317" }}>
                  <li className="nav-item">
                    <Link to="/AddScenarioEnvironment" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>Add</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/ScenarioEnvironmentList" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>List</span>
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Add Character */}
              <li className="nav-item start">
                <a href="#" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i class="fa-solid fa-person" style={{ color: "#FFFFFF" }}></i>
                  <span className="title" style={{ color: "#FFFFFF" }}>Character</span>
                  <span className="selected" style={{ color: "#FFFFFF" }}></span>
                  <span className="arrow" style={{ color: "#FFFFFF" }}></span>
                </a>
                <ul className="sub-menu" style={{ backgroundColor: "#0c1317" }}>
                  <li className="nav-item">
                    <Link to="/AddCharacter" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>Add</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/CharacterList" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>List</span>
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Add Animator Controller */}
              <li className="nav-item start">
                <a href="#" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i class="fa-solid fa-person" style={{ color: "#FFFFFF" }}></i>
                  <span className="title" style={{ color: "#FFFFFF" }}>Animator</span>
                  <span className="selected" style={{ color: "#FFFFFF" }}></span>
                  <span className="arrow" style={{ color: "#FFFFFF" }}></span>
                </a>
                <ul className="sub-menu" style={{ backgroundColor: "#0c1317" }}>
                  <li className="nav-item">
                    <Link to="/AddAnimator" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>Add</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/AnimatorList" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>List</span>
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Add Custom 11Labs Voices */}
              <li className="nav-item start">
                <a href="#" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i className="fa-solid fa-microphone" style={{ color: "#FFFFFF" }}></i>
                  <span className="title" style={{ color: "#FFFFFF" }}>Voices</span>
                  <span className="selected" style={{ color: "#FFFFFF" }}></span>
                  <span className="arrow" style={{ color: "#FFFFFF" }}></span>
                </a>
                <ul className="sub-menu" style={{ backgroundColor: "#0c1317" }}>
                  <li className="nav-item">
                    <Link to="/AddVoice" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>Add</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/VoiceList" className="nav-link">
                      <span className="title" style={{ color: "#FFFFFF" }}>List</span>
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Eleven Labs Error logs */}
              <li className="nav-item start active open">
                <Link to="/TTSLog" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i className="fa-solid fa-file-lines" style={{ color: "#FFFFFF" }}></i>
                  <span className="title" style={{ color: "#FFFFFF" }}>TTS Log</span>
                </Link>
              </li>

              {/* usage count */}
              <li className="nav-item start">
                <Link
                  to="/PortalCharStats"
                  className="nav-link nav-toggle"
                  style={{ backgroundColor: "#1e2e38" }}
                >
                  <i className="fa-solid fa-chart-line" style={{ color: "#FFFFFF" }}></i>
                  <span className="title" style={{ color: "#FFFFFF" }}>Portal Character Graphs</span>
                </Link>
              </li>

              <li className="nav-item start active open">
                <a href="https://vimeo.com/showcase/10538430" target="_blank" className="nav-link nav-toggle" style={{ backgroundColor: "#1e2e38" }}>
                  <i data-feather="help-circle" style={{ color: "#FFFFFF" }}></i>

                  <span className="title" style={{ color: "#FFFFFF" }}>Tutorial</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* <!-- end sidebar menu --> */}
      {/* <!-- start page content --> */}
    </>
  );
};

export default SidebarContainer;
